import { InjectionToken } from '@angular/core';
import { z } from 'zod';

export const authModeSchema = z.enum(['mock', 'keycloak']);
export type AuthMode = z.infer<typeof authModeSchema>;

export const demoUserConfigSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  role: z.string(),
  tenantIds: z.array(z.string()),
  locationIds: z.array(z.string())
});
export type DemoUserConfig = z.infer<typeof demoUserConfigSchema>;

export const authConfigSchema = z.object({
  mode: authModeSchema,
  keycloakUrl: z.string(),
  realm: z.string(),
  clientId: z.string(),
  redirectUri: z.string(),
  logoutRedirectUri: z.string()
});

export const wifiConfigSchema = z.object({
  primarySsid: z.string(),
  eventSsid: z.string()
});

export const brandingConfigSchema = z.object({
  companyName: z.string(),
  version: z.string(),
  logoPath: z.string()
});

export const appEnvironmentSchema = z.object({
  production: z.boolean(),
  appName: z.string(),
  apiBaseUrl: z.string(),
  branding: brandingConfigSchema,
  auth: authConfigSchema,
  demoUser: demoUserConfigSchema,
  wifi: wifiConfigSchema
});
export type AppEnvironment = z.infer<typeof appEnvironmentSchema>;

export const APP_ENV = new InjectionToken<AppEnvironment>('APP_ENV');

export function defineAppEnvironment(environment: AppEnvironment): AppEnvironment {
  return appEnvironmentSchema.parse(environment);
}

export function resolveAppUrl(value: string, baseUri: string = document.baseURI): string {
  return new URL(value, baseUri).toString();
}
